<template>
  <div class="data-log">
    <header class="topic-title">项目日志</header>
    <div class="filter-wrap">
      <common-select
        label="全部时间"
        type="time"
        @select="filterLog($event, 'dates')"
      ></common-select>
      <common-select
        label="所有人"
        :options="operatorOptions"
        @select="filterLog($event ? [$event] : [], 'op')"
      ></common-select>
      <!--<common-select-->
      <!--  :options="typeOptions"-->
      <!--  @select="filterLog($event ? [$event] : [], 'types')"-->
      <!--&gt;</common-select>-->
    </div>
    <div v-ps class="log-list">
      <div class="log-item font-main" v-for="(log, index) in filteredLogs" :key="index">
        <div class="log-time">{{ log.time }}</div>
        <div class="log-content">
          <staff-popover :staffId="log.user.id">
            <template v-slot:reference>
              <el-tooltip
                :content="log.user.name || '无'"
                placement="top"
                :disabled="!log.user.id || log.user.id.length > 3"
              >
                <staff-avatar class="avatar" :size="30" :user="log.user"></staff-avatar>
              </el-tooltip>
            </template>
          </staff-popover>
          <div class="log-text">
            <div class="log-title">{{ log.title }}</div>
            <div v-if="log.detail && log.detail.length">
              <div v-for="(item, index) in log.detail" :key="index">
                {{ item.ctrlName }}：
                <a
                  :class="item.oldExt ? 'external-link pointer' : ''"
                  @click="item.oldExt && download(item.oldExt, oldStr)"
                >
                  {{ item.oldStr }}
                </a>
                ->
                <a
                  :class="item.newExt ? 'external-link pointer' : ''"
                  @click="item.newExt && download(item.newExt, newStr)"
                >
                  {{ item.newStr }}
                </a>
                <br />
              </div>
            </div>
            <div v-else>
              <div v-for="(item, index) in log.content" :key="index">
                {{ item }}
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectLogList } from "@/api/project/project"
import CommonSelect from "@/components/UIComponents/CommonSelect"
import dj from "dayjs"
import { signature } from "@/utils/aliOss"
import { loadingService } from "@/utils/ui"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "ProjectLog",
  props: {
    projectId: String
  },
  components: {
    StaffAvatar,
    CommonSelect,
    StaffPopover
  },
  watch: {
    projectId: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  data() {
    return {
      logSearchBody: {
        types: [],
        op: [],
        dates: null
      },
      typeOptions: [
        {
          value: "user",
          label: "用户操作"
        },
        {
          value: "sys",
          label: "系统操作"
        },
        {
          value: "verify",
          label: "审批"
        }
      ],
      type: "all",
      logs: [],
      filteredLogs: []
    }
  },
  computed: {
    operatorOptions() {
      let res = {}
      this.logs.forEach(log => {
        let id = log.userId
        res[id] = {
          value: id,
          label: log.user?.name
        }
      })
      return Object.values(res)
    }
  },
  methods: {
    init() {
      let logTitleMap = {
        PROJECT_CREATE: "【创建】了项目",
        PROJECT_UPDATE: "【编辑】了项目",
        PROJECT_DELETE: "【解散】了项目",
        PROJECT_ARCHIVE: "【归档】了项目",
        PROJECT_ARCHIVE_CANCEL: "【取消归档】了项目",
        PROJECT_CREATE_GROUP: "【创建】了分组",
        PROJECT_UPDATE_GROUP: "【编辑】了分组",
        PROJECT_DELETE_GROUP: "【删除】了分组",
        PROJECT_PUBLIC_TRUE: "【关闭】了隐私模式",
        PROJECT_PUBLIC_FALSE: "【开启】了隐私模式"
      }
      // 获取log
      if (!this.projectId) return
      getProjectLogList(this.projectId).then(logs => {
        logs = logs.map(log => {
          log.title = logTitleMap[log.type]
          log.time = log.createAt.replace(" ", "\n")
          log.content = log.extra ? log.extra.split(";") : []
          return log
        })
        logs.reverse()
        this.logs = logs
        this.filterLog()
      })
    },
    download(path, name) {
      const loadingInstance = loadingService()
      signature({ objectName: path, downloadName: name }).then(res => {
        loadingInstance.close()
        window.open(res)
      })
    },
    filterLog(value, type) {
      this.logSearchBody[type] = value
      let searchBody = this.logSearchBody
      let isBetween = require("dayjs/plugin/isBetween")
      dj.extend(isBetween)
      this.filteredLogs = this.logs.filter(log => {
        // 时间
        if (
          searchBody.dates &&
          log.createAt &&
          !dj(log.createAt).isBetween(searchBody.dates[0], searchBody.dates[1])
        ) {
          return false
        }
        // 操作人
        if (searchBody.op.length && !searchBody.op.includes(log.userId)) {
          return false
        }
        // 类型 最后一个判断
        if (searchBody.types.length) {
          for (let type of searchBody.types) {
            switch (type) {
              case "sys":
                if (log.userId.length < 24) {
                  return true
                }
                break
              case "user":
                if (log.userId.length === 24) {
                  return true
                }
                break
              case "verify":
                if (log.type === "VERIFY") {
                  return true
                }
                break
            }
          }
          return false
        }
        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.data-log {
  display: flex;
  flex-flow: column;
  padding-right: 56px;
  padding-bottom: 60px;
  .log-filter {
    margin-top: 23px;
  }
  .filter-wrap {
    display: flex;
    .common-select {
      margin-right: 20px;
    }
  }
  .log-list {
    flex: auto;
    display: flex;
    flex-direction: column;
    margin-top: 17px;
    .log-item {
      display: flex;
      .log-time {
        flex-shrink: 0;
        text-align: right;
        white-space: pre;
        padding-right: 13px;
      }
      .log-content {
        display: flex;
        padding: 0 10px 30px 13px;
        border-left: 2px solid $color-bg-home;
        .avatar {
          flex-shrink: 0;
        }
        .log-text {
          .log-title {
            margin-left: -8px;
            line-height: 25px;
          }
          .external-link {
            color: $color-main;
          }
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
